import { createCrud } from '@lumahealthhq/ui-model';
var basePath = 'broadcastFlows';
var crud = createCrud(basePath);

/* Default queries */
export var useBroadcastFlowCount = crud.makeCount();
export var useBroadcastFlowById = crud.makeFindById();
export var useBroadcastFlowByIds = crud.makeFindByIds();
export var useBroadcastFlowMany = crud.makeFindMany();
export var useBroadcastFlowOne = crud.makeFindOne();
export var useBroadcastFlowPagination = crud.makePagination();

/* Default mutations */
export var useBroadcastFlowCreateOne = crud.makeCreateOne();
export var useBroadcastFlowUpdateOne = crud.makeUpdateOne();
export var useBroadcastFlowRemoveById = crud.makeRemoveById();

/* Custom queries */

/* Custom mutations */